import React from 'react';
import { Link } from 'react-router-dom';
import AuthShell from './AuthShell';
import AuthError from './AuthError';
import AccountStep from './steps/AccountStep';
import SecurityStep from './steps/SecurityStep';
import RegistrationSuccess from './steps/RegistrationSuccess';

// Presentational content for every Register V2 step. Register.js (the
// controller) owns all state/handlers and Firebase/session calls; this
// component only renders the current step and forwards DOM events upward.
export default function RegisterView({
  step, headingRef,
  name, email, password, confirmPassword,
  errors, topError, emailInUse, loading,
  passwordRequirements, passwordScore,
  onNameChange, onEmailChange, onPasswordChange, onConfirmPasswordChange,
  onGoogleRegister, onContinueToSecurity, onBackToAccount, onSubmit, onGoToDashboard,
  verifiedNote,
}) {
  return (
    <AuthShell lean={step === 'success'}>
      <AuthError message={topError} tone="error" />
      {emailInUse && (
        <p className="auth-footer-line" style={{ marginTop: -10, marginBottom: 18 }}>
          <Link to="/login">Se connecter avec cette adresse</Link>
        </p>
      )}

      {step === 'account' && (
        <AccountStep
          headingRef={headingRef}
          name={name}
          email={email}
          errors={errors}
          loading={loading}
          onNameChange={onNameChange}
          onEmailChange={onEmailChange}
          onGoogleRegister={onGoogleRegister}
          onContinue={onContinueToSecurity}
        />
      )}

      {step === 'security' && (
        <SecurityStep
          headingRef={headingRef}
          password={password}
          confirmPassword={confirmPassword}
          errors={errors}
          loading={loading}
          passwordRequirements={passwordRequirements}
          passwordScore={passwordScore}
          onPasswordChange={onPasswordChange}
          onConfirmPasswordChange={onConfirmPasswordChange}
          onBack={onBackToAccount}
          onSubmit={onSubmit}
        />
      )}

      {step === 'success' && (
        <RegistrationSuccess headingRef={headingRef} onContinue={onGoToDashboard} verifiedNote={verifiedNote} />
      )}
    </AuthShell>
  );
}
